import kiosk from './kiosk';
import permits from "./permits";

export default {
  namespaced: true,
  modules: {
    kiosk,
    permits
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/index.js